import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-delete-notebook-dialog',
  template: `
  <h2 mat-dialog-title>Are you sure you want to delete this notebook?</h2>
  <mat-dialog-content>All notes inside it will be deleted too</mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button [mat-dialog-close]="false">Cancel</button>
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Delete</button>
  </mat-dialog-actions>
  `,
  styles: [
  ]
})
export class DeleteNotebookDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
